"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.courseByCode = exports.LoginMooc = void 0;
exports.getCodeImg = getCodeImg;
exports.webZyk = exports.webConfig = exports.sendLoginMessage = exports.selectList = exports.registerBySms = exports.loginBySms = exports.icveLogin = exports.getMoocImg = exports.getImgCode = exports.getCourse8 = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取类型列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * businessTypeId 1 文件类型 2 作品项类型 3 院校类型
 * @returns {any}
 */
var selectList = exports.selectList = function selectList(data) {
  return _api.default.request({
    url: '/common/getConfigs',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

// 登录方法
// export function login(username, password, code, uuid, type) {
//   // console.log('type',type)
//   return request({
//     url: '/auth/login',
//     headers: {
//       isToken: false
//     },
//     method: 'post',
//     data: { username, password, code, uuid, type }
//   })
// }

// 获取验证码
function getCodeImg() {
  return _api.default.request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  });
}
var getImgCode = exports.getImgCode = function getImgCode(data) {
  return _api.default.request({
    url: '/common/getImage',
    method: 'post',
    data: data
  });
};
// 获取mooc验证码
var getMoocImg = exports.getMoocImg = function getMoocImg(data) {
  return _api.default.request({
    url: 'https://jiangxi.icve.com.cn/dev-api/VerifyCode',
    method: 'post',
    data: data
  });
};
// mooc学院登录
var LoginMooc = exports.LoginMooc = function LoginMooc(data) {
  return _api.default.request({
    url: "https://jiangxi.icve.com.cn/dev-api/Login",
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 根据省份code获取省精品课程
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var courseByCode = exports.courseByCode = function courseByCode(data) {
  return _api.default.request({
    url: '/web/getCoursesByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取网站logo
 * @author kkdy
 * @date 2021-12-13
 * @param {any} data
 * @returns {any}
 */
var webConfig = exports.webConfig = function webConfig(data) {
  return _api.default.request({
    url: '/web/getWebConfigByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述 
 * @author kkdy
 * @date 2021-12-17
 * @param {any} data
 * @returns {any}
 */
var webZyk = exports.webZyk = function webZyk(data) {
  return _api.default.request({
    url: '/web/getResourceByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述 展示首页8个课程
 * @author kkdy
 * @date 2022-01-17
 * @param {any} data
 * @returns {any}
 */
var getCourse8 = exports.getCourse8 = function getCourse8(data) {
  return _api.default.request({
    url: '/course/indexCourses',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

//国家平台验证码
var sendLoginMessage = exports.sendLoginMessage = function sendLoginMessage(data) {
  return _api.default.request({
    url: '/open/sendLoginMessage',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
var icveLogin = exports.icveLogin = function icveLogin(data) {
  return _api.default.request({
    url: '/user/icveLogin',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
//国家平台登录
var loginBySms = exports.loginBySms = function loginBySms(data) {
  return _api.default.request({
    url: '/open/loginBySms',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
var registerBySms = exports.registerBySms = function registerBySms(data) {
  return _api.default.request({
    url: '/open/registerBySms',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};